import { Component }        from '@angular/core';
import { Router,
         NavigationExtras } from '@angular/router';
import { AuthService }      from '../auth.service';

@Component({
  template: require('./forgotpassword.component.html')
})

export class ForgotPasswordComponent {
  message: string;

  constructor(public authService: AuthService, public router: Router) {
    //this.setMessage();
  }
  
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/account/forgotpassword.component.ts